import React from "react";
//#region types
import { RoundButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Button } from "@mui/material";
import SimpleTooltip from "../tooltips/tooltip";
//#endregion
import { CSSHelper, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const RoundButton: React.FC<RoundButtonProps> = (props) => {
  const { displayType, onClick, disabled, size, hoverText, hoverTextAsToolTip, testId } = props;

  const hasHoverText = !UtilsHelper.isEmpty(hoverText);

  return (
    <div className={cssExports.roundBtnContainer} data-testid={testId}>
      <SimpleTooltip text={hoverText ?? " "} hidden={!hoverTextAsToolTip || !hasHoverText}>
        <Button
          className={clsx(
            cssExports.btnRound,
            hasHoverText && !hoverTextAsToolTip ? cssExports.withAnimation : "",
            size ? cssExports[size] : "",
            CSSHelper.getClassByDisplayType(displayType),
            props.className
          )}
          onClick={onClick}
          disabled={disabled}
          disableRipple
        >
          {props.children}
          {hasHoverText && !hoverTextAsToolTip ? (
            <span className={cssExports.roundBtnHoverText}>{hoverText}</span>
          ) : (
            <></>
          )}
        </Button>
      </SimpleTooltip>
    </div>
  );
};

export default RoundButton;
